import { LoadingGlobe } from './LoadingGlobe'

/** Full-screen fallback used for route transitions and the root Suspense boundary. */
export function RouteSpinner() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-white/85">
      <LoadingGlobe />
    </div>
  )
}
